#import "@core/schema/fragments/NewsFull.graphql"

mutation (
  $otp: String!
  $newsId: ID!
) {
  verifyNewsOtp(
    otp: $otp
    newsId: $newsId
  ) {
    ...NewsFull
  }
}
